<template>
	<div :style="outerStyle">
		<svg :width="size" :height="size">
		  <defs>
		    <mask id="hole">
		      <rect width="100%" height="100%" fill="white"/>
		      <circle :r="maskR" :cx="maskCenter" :cy="maskCenter" fill="black"/>
		    </mask>
		  </defs>

		  <path :d="pathScaled" mask="url(#hole)" :fill="scaleColor"></path>
		  <path :d="pathPassed" mask="url(#hole)" :fill="fillColor"></path>
		</svg>
	</div>
</template>

<script>
  export default {
      // radius - larger arc's radius in pixels
      // larger arc starts at startAngle (40) degrees from -180 (left)
      // value e [0, 100]
      // color - string like blue or #fff
      // thickness e [1, 100], 1 - line arc, 100 - circle
      props: ['radius', 'value', 'colorval', 'colorscale', 'thickness'],
      data() {
        return {
        	startAngle: 40
        };
      },
      computed: {
      	outerStyle() {
      		let r = this.radius ? this.radius : 110;
      		let w = Math.floor(Math.cos(this.startAngle * Math.PI / 180) * r * 2) + 1;
      		let x = Math.floor((1 - Math.cos(this.startAngle * Math.PI / 180)) * r) + 1;
      		let h = r - Math.floor(Math.sin(this.startAngle * Math.PI / 180) * this.maskR);
      		return `width:${w}px; height:${h}px; margin-left:${-x}px`;
      	},
      	fillColor() {
      		return this.colorval ? this.colorval : '#a0ff90';
      	},
      	scaleColor() {
      		return this.colorscale ? this.colorscale : '#cece90';
      	},
      	pathPassed() {
      		let percent = this.value;
      		if (percent < 0) percent = 0;
      		else if (percent > 100) percent = 100;
            let b1 = this.startAngle; // arc starts from (180 - b1) degrees
        	let b2 = 180 - b1;
        	let a = percent * (180 - b1*2) / 100;
        	a = b2 - a;
        	return this.makePath(b2, a);
      	},
      	pathScaled() {
      		let percent = this.value;
            let b1 = this.startAngle; // arc starts from (180 - b1) degrees
        	let b2 = 180 - b1;
        	return this.makePath(b2, b1);
      	},
      	size() {
      		let d = this.radius ? this.radius : 110;
      		return d * 2;
      	},
      	maskR() {
      		let thk = this.thickness;
      		if (thk === undefined || thk < 1) thk = 65;
      		if (thk > 100) thk = 100;
      		
      		let R = this.radius ? this.radius : 110;
      		if (thk === 1) return R - 1;
      		if (thk === 100) return 1;

      		return Math.floor(R * thk / 100) + 1;
      	},
      	maskCenter() {
      		return this.radius ? this.radius : 110;
      	}
      },
      methods: {
      	makePath(b2, a) {
      		let r = this.radius ? this.radius : 110;
      		let percent = this.value;
      		let o = [r, r];
	        let m = [o[0] + r * Math.cos(b2 * Math.PI / 180),
	                 o[1] - r * Math.sin(b2 * Math.PI / 180)];
	        let l = [o[0] + r * Math.cos(a * Math.PI / 180),
	                 o[1] - r * Math.sin(a * Math.PI / 180)];
	        return `M ${r} ${r} L ${m[0]} ${m[1]} A ${r} ${r}, 0, 0, 1, ${l[0]} ${l[1]} L ${r} ${r}`;
      	}
      }
    };
</script>